import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router'
import { AuthLayout } from './AuthLayout'
import { PLAY_STORE_URL } from './NoAccount'

/** web_setup_incomplete: faction or age gate not passed yet — both are answered in the app. */
export function SetupIncomplete() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const step = params.get('step') === 'age' ? 'age' : 'faction'
  return (
    <AuthLayout>
      <div className="soc-card relative p-7">
        <span aria-hidden className="absolute inset-x-0 top-0 h-[3px] bg-warning" />
        <p className="soc-label text-warning">{t('setup.kicker')}</p>
        <h1 className="soc-title mt-2 text-[26px]">{t('setup.title')}</h1>
        <p className="mt-4 text-ink-soft" data-testid="setup-step">
          {t(step === 'age' ? 'setup.age' : 'setup.faction')}
        </p>
        <p className="mt-3 text-[14px] text-ink-mute">{t('setup.thenReturn')}</p>
        <a className="soc-btn soc-btn-primary mt-6 w-full" href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
          {t('setup.openApp')}
        </a>
        <Link to="/login" className="soc-btn soc-btn-ghost mt-3 w-full">
          {t('nav.backToSignIn')}
        </Link>
      </div>
    </AuthLayout>
  )
}
